export default function () {
  const parseContent = dynamicContent => {
    dynamicContent.value = dynamicContent['content-value'];
    return dynamicContent;
  };

  const parseContents = dynamicContents => {
    if (dynamicContents == null) return;
    dynamicContents.map(c => parseContent(c));
    return dynamicContents;
  };

  return {
    parseContent,
    parseContents
  };
}
